import React from "react";
import { connect } from "react-redux";
import { Header, Modal, Label, Icon } from "semantic-ui-react";
import UserData from "../user/UserData";
import Flagship from "../../core/flagship";
import { empty, isEqual } from "../../utils/helpers";

class UserDataModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.getUserData = this.getUserData.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  getInitialState() {
    return {
      ...this.props,
      open: false,
      userImage: Flagship.config.uploads + this.props.photo,
      userId: !empty(this.props.id) ? this.props.id : this.props.getUser,
      loading: true
    };
  }

  componentDidMount() {
    this.getUserData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps, this.props)) {
      let getUserData = this.getUserData;

      this.setState(
        {
          loading: true
        },
        function() {
          getUserData(nextProps);
        }
      );
    }
  }

  getUserData(props) {
    if (!empty(props.getUser)) {
      let self = this;

      Flagship.get(
        "user/" + props.getUser,
        {},
        function(response) {
          if (response.data.success === true) {
            self.setState({
              ...response.data.user,
              userImage: Flagship.config.uploads + response.data.user.photo,
              loading: false
            });
          }
        },
        function(err) {
          Flagship.error(
            "Error getting user data: " + err,
            self.props.routeParams.splat,
            props.userId
          );
        }
      );
    }
  }

  handleUserImageError() {
    this.setState({
      userImage: Flagship.config.uploads + "someone.png"
    });
  }

  onOpen(e = null) {
    if (e !== null) {
      e.preventDefault();
    }
    this.setState({
      open: true
    });
  }

  onClose() {
    this.setState({
      open: false
    });
  }

  render() {
    return (
      <div>
        <a
          href={"/user/view/" + this.state.userId}
          target="blank"
          onClick={this.onOpen}
        >
          {this.state.first_name} {this.state.last_name}
        </a>

        <Modal open={this.state.open} onClose={this.onClose} closeIcon>
          <Header className="cf">
            <div className="record-meta float-right">
              <Label color="grey" image size="large">
                {this.state.market}
                <Label.Detail>Market</Label.Detail>
              </Label>
            </div>
            <Icon name="user" className="header-icon" />
            <div className="content">
              {this.state.first_name + " " + this.state.last_name}
            </div>
          </Header>

          <Modal.Content className="cf">
            <UserData userData={this.state} />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(UserDataModal);



// WEBPACK FOOTER //
// ./src/components/modals/UserDataModal.js